import { render, staticRenderFns } from "./search-filter.vue?vue&type=template&id=08a0e638&scoped=true&"
import script from "./search-filter.vue?vue&type=script&lang=js&"
export * from "./search-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a0e638",
  null
  
)

export default component.exports